var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTool = function SvgTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 21.5,
    r: 2.5,
    stroke: "#191919",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11v-.75a.75.75 0 0 0-.748.807L18 11Zm4 0 .748.057A.75.75 0 0 0 22 10.25V11Zm-1 13v.75h.695l.053-.692L21 24Zm-2 0-.748.058.053.692H19V24Zm-1-12.25h4v-1.5h-4v1.5Zm3.252-.807-1 13 1.496.114 1-13-1.496-.114Zm-1.504 13-1-13-1.496.114 1 13 1.496-.114ZM21 23.25h-1v1.5h1v-1.5Zm-1 0h-1v1.5h1v-1.5Z",
    fill: "#191919"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16 6 .4-.3a6 6 0 0 1 7.2 0l.4.3-2 5h-4l-2-5Z",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13h2",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v0a9.487 9.487 0 0 1 6 0v0M8 10v0a4.472 4.472 0 0 1 4 0v0",
    stroke: "#191919",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m7.32 18.372-.317.68 1.36.633.317-.68-1.36-.633Zm7.276-12.055a.75.75 0 0 0-1.36-.634l1.36.634ZM8.68 19.005l5.916-12.688-1.36-.634L7.32 18.372l1.36.633Z",
    fill: "#191919"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    transform: "matrix(-1 0 0 1 13.418 21.5)",
    stroke: "#191919",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m12.598 18.372.317.68-1.36.633-.317-.68 1.36-.633ZM5.322 6.317a.75.75 0 0 1 1.359-.634l-1.36.634Zm5.916 12.688L5.322 6.317l1.359-.634 5.917 12.689-1.36.633Z",
    fill: "#191919"
  })));
};

export default SvgTool;